import Component from './Devices.vue';

export default Component;
